import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Typography,
  IconButton,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { makeStyles } from "@material-ui/core/styles";

/* ------------------------- Importaciones internas ------------------------- */
import { cancelButton, saveButton } from "../../../../core/styles/ui.constants";
import { useAuth } from "../../../../contexts/AuthContext";
import BotonGenerico from "../../../../components/Button/Button";
import DialogFooter from "../../../../components/DialogFooter/DialogActions";

/* --------------------------------- Estilos -------------------------------- */
const useStyles = makeStyles((theme) => ({
  dialogContent: {
    padding: theme.spacing(4),
    minWidth: "600px",
  },
  formRow: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  fullRow: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  modalTitle: {
    textAlign: "left",
    fontSize: "1.5rem",
    fontWeight: "bold",
  },
  closeButton: {
    position: "absolute",
    top: theme.spacing(1),
    right: theme.spacing(1),
  },
  gridItem: {
    marginBottom: theme.spacing(2),
  },
  guardarButton: saveButton,
  cancelarButton: cancelButton,
  attachFileButton: {
    display: "flex",
    alignItems: "center",
  },
}));

const ModalSeguimiento = ({
  open,
  handleClose,
  onSuccess,
  ordenServicio,
  usuarioLocal,
}) => {
  const classes = useStyles();

  // Usuario local
  const { getUser } = useAuth();
  const user = getUser();

  const initialState = {
    idOS: "",
    idUsuario: "",
    fechaCreacion: new Date().toISOString().split("T")[0],
    fechaInicio: new Date().toISOString().split("T")[0],
    observaciones: "",
  };

  const [state, setState] = useState(initialState);
  const [errors, setErrors] = useState({});

  const handleSave = () => {
    if (!usuarioLocal) usuarioLocal = user;

    const seguimiento = {
      idOS: ordenServicio.idOS,
      idUsuario: usuarioLocal?.IdUsuario,
      fechaCreacion: state.fechaCreacion,
      fechaInicio: state.fechaInicio,
      observaciones: state.observaciones,
    };

    onSuccess(seguimiento);
    close();
  };

  const close = () => {
    setState(initialState);
    setErrors({});
    handleClose();
  };

  // const handleAttach = () => {
  //   document.getElementById("file-input").click();
  // };

  return (
    <Dialog open={open} onClose={close} maxWidth="sm">
      <DialogTitle disableTypography>
        <Typography variant="h6" align="left">
          Ingresar Seguimiento
        </Typography>
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={close}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent className={classes.dialogContent}>
        <div className={classes.formRow}>
          <Typography variant="subtitle1">Fecha Inicio</Typography>
          <TextField
            variant="outlined"
            type="date"
            fullWidth
            value={state.fechaInicio}
            error={!!errors.fechaInicio || undefined}
            onChange={(e) =>
              setState((prev) => ({ ...prev, fechaInicio: e.target.value }))
            }
          />
        </div>
        <div className={classes.formRow}>
          <Typography variant="subtitle1">Observaciones</Typography>
          <TextField
            variant="outlined"
            multiline
            rows={3}
            value={state.observaciones || ""}
            onChange={(e) => {
              const value = e.target.value;
              setState((prev) => ({ ...prev, observaciones: value }));
            }}
          />
        </div>
      </DialogContent>

      <DialogFooter>
        <BotonGenerico
          tipo="guardar"
          color="primary"
          onClick={handleSave}
          text="Guardar"
        />
        <BotonGenerico
          tipo="cancelar"
          color="secondary"
          onClick={close}
          text="Cancelar"
        />
      </DialogFooter>
    </Dialog>
  );
};

export default ModalSeguimiento;
